import { CardsStates } from "./enums/cardsStates";

/**  Данные по карте. */
export class CardData {
  /** Идентификатор в ДБО. */
  public Id: number = 0;

  public cardNumberColor: string = '';

  /** Состояние карты. */
  public CardState: CardsStates = 0;

  /** Алиас. */
  public Alias: string = "";

  /** ИД в Retail. */
  public ReferenceId: string = "";

  /** Наименование типа пластика. */
  public PlasticType: string = "";

  /** Номер. */
  public Number: string = "";

  /** Срок действия карты. */
  public ExpDate: string = "";

  /** Эмбоссированное имя. */
  public EmbossedName: string = "";

  /** Код изображения карты. */
  public CodeCardImage: string = "";

  /** Номер мобильного телефона для SMS-уведомлений. */
  public SmsPhone: string = "";

  /** Cостояние SMS-уведомления по номеру мобильного телефона. */
  public SmsStateCode: number = 0;

  /** Базовая процентная ставка кешбэка. */
  public CashbackRate: number = 0;

  /** BIN карты. */
  public BIN: string = "";

  public ViberService: string | null = null;

  public MainCard: string | null = null;

  public SmsService: string | null = null;

  public ReissuedCatId: string | null = null;

  public IsVirtualCard: boolean = false;

  /** Скрытая. */
  public Hidden: boolean = false;

  public TariffName: string = '';

  public TariffUrl: string = '';

  public Rest: number = 0;

  /** Заголовок кэшбэка */
  public currentCaption: string = "";

  /** Картинка кэшбэка */
  public currentImage: string = "";

  /** Краткое описание */
  public currentDescription: string = "";

  /** Полное описание */
  public currentFullDescription: string = "";

  /** Бонусы за месяц. */
  public sumMonth: number = 0;

  /** Бонусы всего */
  public sumItogo: number = 0;

  /** Минимум бонусов */
  public sumMin: number = 0;

  /** Максимум бонусов */
  public sumMax: number = 0;

  /** Режим доступности выбора: 0 - недоступно (нет кнопки), 1-заблокировано, 2-разрешено */
  public selectMode: number = 0;

  /** Сообщение, использование зависит от SelectMode:
  0 - не используется.
  1 - показывается клиенту в окне выбора, при этом выбор заблокирован.
  2 - маска сообщения-подтверждения от клиента при выборе категории, внутри {0} для наименования выборанной категории.*/
  public selectMessage: string = "";

  /** Режим доступности перевода: 0 - недоступно (нет кнопки), 1-заблокировано, 2-разрешено. */
  public transferMode: number = 0;

  /** Сообщение о причине недоступности (при TransferMode=1) */
  public transferMessage: string = "";

  public categories: Array<{
    caption: string;
    image: string;
    description: string;
    fullDescription: string;
  }> = [];
  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {

      this.Id = src.Id ?? 0;
      this.CardState = (src.State ?? 0) as CardsStates;
      this.Alias = src.Alias ?? "";
      this.ReferenceId = src.ReferenceId ?? "";
      this.PlasticType = src.PlasticType ?? "";
      this.Number = src.Number ?? "";
      this.ExpDate = src.ExpDate ?? "";
      this.EmbossedName = src.EmbossedName ?? "";
      this.CodeCardImage = src.CodeCardImage ?? "";
      this.SmsPhone = src.SmsPhone ?? "";
      this.SmsStateCode = src.SmsStateCode ?? "";
      this.CashbackRate = src.CashbackRate ?? 0;
      this.BIN = src.BIN ?? "";
      this.Hidden = src.Hidden ?? false;
      this.IsVirtualCard = src.IsVirtualCard ?? false;
      this.TariffName = src.TariffName ?? "";
      this.TariffUrl = src.TariffUrl ?? "";

      this.parseCustomFields(src);
    }
  }

  private parseCustomFields(src: any): void {
    const sXml: string = src.CustomFields ?? "";

    // Парсим XML.
    const parser = new DOMParser();
    const xDoc = parser.parseFromString(sXml, "text/xml");

    const xmlFields = xDoc.getElementsByTagName("Field");

    const CustomFields: Array<string> = [
      "SmsService",
      "ViberService",
      "MainCard",
      "CashbackCategoryData",
      "ReissuedCatId",
    ];

    for(const j in CustomFields) {
      const key = CustomFields[j];
      for (let i = 0; i < xmlFields.length; i++) {
        const field = xmlFields[i];
        if (field.getAttribute('name') == key) {
          this[key] = field.getAttribute('value');

          if (key === 'CashbackCategoryData') {
            const xmlCashbackCategoryData = parser.parseFromString(this[key], "text/xml");
            
            // Извлечение данных Current
            const current = xmlCashbackCategoryData.getElementsByTagName('Current')[0];
            this.currentCaption = current.getAttribute('Caption') ?? "";
            this.currentImage = current.getAttribute('Image') ?? "";
            this.currentDescription = current.getAttribute('Description') ?? "";
            this.currentFullDescription = current.getAttribute('FullDescription') ?? "";

            // Извлечение данных Cashback
            const cashback = xmlCashbackCategoryData.getElementsByTagName('Cashback')[0];
            this.sumMonth = parseFloat(cashback.getAttribute('SumMonth') ?? "0");
            this.sumItogo = parseFloat(cashback.getAttribute('SumItogo') ?? "0");
            this.sumMin = parseFloat(cashback.getAttribute('SumMin') ?? "0");
            this.sumMax = parseFloat(cashback.getAttribute('SumMax') ?? "0");

            // Извлечение данных Select
            const select = xmlCashbackCategoryData.getElementsByTagName('Select')[0];
            this.selectMode = parseInt(select.getAttribute('Mode') ?? "0");
            this.selectMessage = select.getAttribute('Message') ?? "";

            // Извлечение данных Transfer
            const transfer = xmlCashbackCategoryData.getElementsByTagName('Transfer')[0];
            this.transferMode = parseInt(transfer.getAttribute('Mode') ?? "0");
            this.transferMessage = transfer.getAttribute('Message') ?? "";

            // Извлечение данных Categories и Category
            const categories = xmlCashbackCategoryData.getElementsByTagName('Category');
            this.categories = [];
            for (let i = 0; i < categories.length; i++) {
              const category = categories[i];
              this.categories.push({
                caption: category.getAttribute('Caption') ?? "",
                image: category.getAttribute('Image') ?? "",
                description: category.getAttribute('Description') ?? "",
                fullDescription: category.getAttribute('FullDescription') ?? "",
              });
            }
          }
        }
      }
    }
  }

  /**Обновить счет */
  public update(card: CardData): void {
    this.CardState = card.CardState;
    this.Alias = card.Alias;
  }
}
